<template>
  <div class="vm-nav-tab-mobile">
    <router-link to="/feed" class="tab-item relative" active-class="on">
      <i class="afd afd-afdian"></i>
      <div class="fs12 item-tit">{{$t('c.NavTabMobile.text1')}}</div>
      <i v-if="unread_post_num > 0" class="red-point"></i>
    </router-link>
    <router-link to="/explore" class="tab-item" active-class="on">
      <i class="afd afd-explore"></i>
      <div class="fs12 item-tit">{{$t('c.NavTabMobile.text2')}}</div>
    </router-link>
    <div class="tab-item add-btn-box" v-if="is_creator" @click="$mixin_show_modal_feed()">
      <div class="add-btn">
        <div class="inner-box">
          <i class="afd afd-plus"></i>
        </div>
      </div>
    </div>
    <router-link class="tab-item" to="/message" active-class="on">
      <i class="afd afd-mail"></i>
      <div class="fs12 item-tit">{{$t('c.NavTabMobile.text3')}}</div>
      <tag class="cyan circle" v-if="unread_message_num">
        {{
        unread_message_num > 99 ? "99+" : unread_message_num
        }}
      </tag>
    </router-link>
    <router-link
      class="tab-item"
      :to="!is_applying_apple && !is_applying_google && is_creator ? '/dashboard/stats' : '/dashboard/sponsoring'"
      active-class="on"
    >
      <i class="afd afd-user"></i>
      <div class="fs12 item-tit">{{$t('c.NavTabMobile.text4')}}</div>
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "nav-tab-mobile",
  props: {},
  computed: {
    ...mapState("app", [
      "session_user",
      "unread_message_num",
      "unread_post_num",
      'is_applying_apple',
      "is_applying_google"
    ]),
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="stylus" scoped>
.vm-nav-tab-mobile {
  background: $white;
  height: $nav-mobile-height;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  box-shadow: 0 _px2rem(4) px2rem(10) $black-1;
  z-index: 13;

  @media (display-mode: fullscreen), (display-mode: standalone){
    padding-bottom: $afd-safe-area-bottom;
  }

  .red-point {
    position: absolute;
    width: px2rem(6);
    height: px2rem(6);
    border-radius: 100px;
    background: $red;
    left: 50%;
    top: px2rem(8);
    margin-left: px2rem(4);
    border: 3px solid $white-bg;
  }

  .tab-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 5;
    padding: px2rem(10) 0;
    position: relative;
    flex-direction: column;

    &.on {
      .item-tit, .afd {
        color: $purple;
      }
    }

    .item-tit {
      color: $black-3;
    }

    .afd {
      font-size: 22px;
      color: $black-3;
    }
  }

  .vm-tag {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(40%, 30%);
  }

  .add-btn-box {
    flex: 4;
  }

  .add-btn {
    border-radius: 1000px;
    border: 4px solid $purple-1;

    .inner-box {
      /* padding 10px */
      background: $purple;
      border-radius: 1000px;
      width: px2rem(48);
      height: px2rem(48);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .afd {
      font-size: 16px;
      color: $white;
    }

    transform: translateY(-10px);
  }
}
</style>
